/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.13"
        height="119.1"
        viewBox="0 0 82.13 119.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M19.82 62.43a1.24 1.24 0 0 1 1.24 1.12v54.3a1.24 1.24 0 0 1-1.12 1.24H1.25a1.252 1.252 0 0 1-.13-2.5h17.45V64.93H1.25a1.24 1.24 0 0 1-1.24-1.12v-.13a1.26 1.26 0 0 1 1.12-1.25h18.7ZM74.76 79.86A7.371 7.371 0 0 1 75 94.6h-8.16a1.252 1.252 0 0 1-.13-2.5h8.05a4.871 4.871 0 0 0 .21-9.74h-8.13a1.25 1.25 0 0 1-.13-2.49h8.05Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M73.85 92.11a7.371 7.371 0 0 1 .24 14.74h-7.25a1.25 1.25 0 0 1-.13-2.49h7.14a4.871 4.871 0 0 0 .21-9.74h-7.22a1.252 1.252 0 0 1-.13-2.5h7.14Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M70.33 104.35a7.371 7.371 0 0 1 .25 14.74h-38.8a6.57 6.57 0 0 1-4.46-1.74l-.21-.2-1.94-1.94a1.61 1.61 0 0 0-1-.46h-4.32a1.25 1.25 0 0 1-.13-2.49h4.31a4.06 4.06 0 0 1 2.74 1l.17.16 1.94 1.93a4 4 0 0 0 2.67 1.2h38.78a4.871 4.871 0 0 0 .22-9.74h-3.71a1.25 1.25 0 0 1-.13-2.49h3.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M16.09 15.06a1.25 1.25 0 0 1 1.67 0l.1.1 14.09 15.09a1.26 1.26 0 0 1-.06 1.75 1.24 1.24 0 0 1-1.67 0l-.1-.09-14.09-15.08a1.25 1.25 0 0 1 .06-1.77ZM71.9 15.13a1.25 1.25 0 0 1 1.77-.07 1.27 1.27 0 0 1 .15 1.67l-.09.1L59.63 32a1.25 1.25 0 0 1-1.91-1.6l.08-.11ZM44.86 0a1.24 1.24 0 0 1 1.24 1.12v23.41a1.24 1.24 0 0 1-1.24 1.25 1.26 1.26 0 0 1-1.25-1.12V1.25A1.25 1.25 0 0 1 44.86 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M44.43 30.2a7.11 7.11 0 0 1 5.95 3.38A13.05 13.05 0 0 1 51.81 37c.88 3.31.67 6.81-.68 12.29l-.24 1-.27 1-.38 1.42-.23.86-.21.82-.18.78-.09.38-.16.73c-.67 3.21-.74 5.39-.12 7.12l.07.19.08.22.1.19.11.25a6.37 6.37 0 0 0 1 1.38 6.24 6.24 0 0 0 4.63 2h18.09a7.38 7.38 0 0 1 .17 14.73h-6.68a1.25 1.25 0 0 1-.13-2.49h6.56a4.871 4.871 0 0 0 .22-9.74H55.5a8.81 8.81 0 0 1-6.79-2.82 8 8 0 0 1-1.68-2.73v-.12l-.07-.17a13.19 13.19 0 0 1-.29-7l.13-.71c.07-.37.15-.74.23-1.13l.18-.79.2-.83.22-.87.24-.9.38-1.41.25-.95.12-.46.22-.88.19-.84c0-.14.07-.28.1-.41l.16-.79c.75-3.74.78-6.3.16-8.66a10.94 10.94 0 0 0-1.14-2.76 4.6 4.6 0 0 0-3.83-2.2c-2.46 0-4.13 1.49-4.69 4.51-3.62 17.28-10.59 27.7-19.36 31.85a1.25 1.25 0 0 1-1.07-2.26c8-3.78 14.51-13.53 18-30.07.69-4.14 3.36-6.53 7.07-6.53Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThumbsUpIcon';

export default Icon;
